<template>
  <div id="app" class="wrapper" style="padding-right: 2px; padding-left: 2px">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <div class="app">
        <br />

        <div style="display: flex; place-content: center">
          <img
            style="
              max-width: 300px;
              max-height: 250px;
              width: 300px;
              height: 250px;
              object-fit: cover;
            "
            v-show="!errorImage"
            v-bind:src="urlImageProduto(contrato, product.cd)"
            v-bind:alt="product.cd"
            @load="errorImage = false"
            @error="errorImage = true"
          />
        </div>

        <div :style="{ color: corTexto }">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">
                  <label class="cor-preta" :style="{ color: corTexto }"
                    ><b>Produto</b></label
                  >
                </th>
                <th scope="col" v-if="product.unitario == '0'">
                  <div style="display: flex; justify-content: center">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b>Peso</b></label
                    >
                  </div>
                </th>
                <th scope="col">
                  <label :style="{ color: corTexto }"><b>Preço</b></label>
                </th>
              </tr>
            </thead>
            <tbody id="listarproduto()">
              <tr>
                <td>
                  <label :style="{ color: corTexto }"
                    ><b>{{ product.nm }}</b></label
                  >
                </td>
                <td v-if="product.unitario == '0'">
                  <input
                    type="number"
                    v-model="peso"
                    class="form-control"
                    id="text"
                    aria-describedby="textHelp"
                    placeholder="Digite o peso"
                  />
                </td>
                <td>
                  <label
                    :style="{ color: corTexto }"
                    class="cor-preta"
                    style="width: 100px; word-wrap: break-word"
                    ><b>R$ {{ totalValorPeso }}</b></label
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <b>Alguma observação ?</b>
          <textarea
            class="form-control"
            v-model="obs"
            id="obs"
            name="obs"
            rows="2"
            placeholder="Ex: Digite as observações aqui..."
          ></textarea>
        </div>

        <div class="modal-footer">
          <button
            style="background-color: #006400"
            @click="addItem(product, adicionaispergunta, obs)"
            type="button"
            class="btn btn-dark"
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Inis from "../services/inis";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "ProdutoUnico",
  data() {
    return {
      corFundo: "",
      corBotao: "",
      corTexto: "",
      corDescricao:"",
      adicionaispergunta: [],
      product: [],
      product: {
        cd: "",
        nm: "",
        classe: "",
        ingredientes: "",
        vl: "",
        vl_promo: "",
      },
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      obs: "",
      peso: "",
      qrCodeTempoExpiracao: 0,
    };
  },
  computed: {
    totalValorPeso() {
      var valor = 0;
      if (this.peso == "") {
        return this.product.vl;
      } else {
        valor = parseFloat(this.peso) * parseFloat(this.product.vl);
        valor = valor.toFixed(2);
        return valor;
      }
    },
    ...mapGetters({
      length: "getNumberOfProducts",
    }),
  },
  methods: {
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis = resposta.data;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((response) => {
        this.corFundo = response.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((response) => {
        this.corBotao = response.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((response) => {
        this.corTexto = response.data[0].vl;
      });
      var cd = "COR_DESCRICAO";
      Inis.listarInisCd(cd).then(resposta => {
        this.corDescricao = resposta.data[0].vl;
      });
      var cd = "TEMPO_QRCODE";
      Inis.listarInisCd(cd).then((response) => {
        this.qrCodeTempoExpiracao = response.data[0].vl;
      });
      console.log(this.qrCodeTempoExpiracao);
    },
    listarproduto() {
      this.product = ls.get("product" + process.env.VUE_APP_CONTRATO);
    },
    addItem(product, adicionaispergunta, obs) {
      var d1 = this.$store.state.date_token;
      var d2 = moment().format("YYYY-MM-DD hh:mm:ss");
      var diff = moment(d2, "YYYY-MM-DD HH:mm:ss").diff(
        moment(d1, "YYYY-MM-DD HH:mm:ss")
      );
      diff = diff / 60000;

      if (this.$store.state.funcionamento === "0") {
        Swal.fire({
          title: "Estabelecimento fechado",
          confirmButtonColor: "#000000",
        });
        //alert("Estabelecimento Fechado");
      } else if (diff > this.qrCodeTempoExpiracao) {
        Swal.fire({
          title: "Tempo de conexão expirou! Leia o QRcode novamente!",
          confirmButtonColor: "#000000",
        });
      } else if (
        (product.unitario == "0" && this.peso == "") ||
        (product.unitario == "0" && this.peso == 0)
      ) {
        Swal.fire({
          title: "Digite o peso em kilogramas",
          confirmButtonColor: "#000000",
        });
      } else if (this.$store.state.funcionamento === "1") {
        if (product.unitario == "0") {
          /*           product.vl = this.totalValorPeso; */
          product.peso = this.peso;
        }

        this.$store.dispatch("addToCart", {
          product,
          adicionaispergunta,
          obs,
        });
        this.$router.push("/cart");
        //adicionaispergunta
        //addToCart({ product, adicionaispergunta });
      }
    },
    urlImageProduto(contrato, prod) {
      return `https://apppanterafood.com.br/DeliveryCenter/${contrato}/produtos/${prod}.jpg?${performance.now()}`;
    },
    erroImagemProduto(event,contrato) {
      event.target.src =
        "https://apppanterafood.com.br/DeliveryCenter/" +
        contrato +
        "/produtos/sem_imagem.jpg";
    },
  },
  mounted() {
    this.contrato = process.env.VUE_APP_CONTRATO;
    this.listarproduto(), this.listarinis();
  },
};
</script>
